package org.teddapp.project.ui.finance

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Finance_account
import org.teddapp.project.ui.TeddCard
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.TeddType

/** Somme des comptes actifs, groupée par devise : on n'additionne jamais deux monnaies. */
internal fun totalsByCurrency(accounts: List<Finance_account>): List<Pair<String, Long>> =
    accounts.filter { it.is_deleted == 0L }
        .groupBy { it.currency }
        .map { (currency, list) -> currency to list.sumOf { it.balance } }
        .sortedByDescending { it.second }

/**
 * Tout mon argent : le total de tous les comptes, devise par devise. La devise principale
 * en grand, les autres dessous. Masqué comme les soldes quand l'œil est fermé.
 */
@Composable
internal fun FinanceTotalCard(
    accounts: List<Finance_account>,
    hideBalance: Boolean,
    modifier: Modifier = Modifier,
    compact: Boolean = false,
) {
    val totals = totalsByCurrency(accounts)
    if (totals.isEmpty()) return
    val (mainCurrency, mainTotal) = totals.first()
    val others = totals.drop(1)
    val activeCount = accounts.count { it.is_deleted == 0L }

    TeddCard(modifier = modifier.fillMaxWidth(), padding = PaddingValues(if (compact) 14.dp else 18.dp)) {
        Text("TOUT MON ARGENT", style = TeddType.Overline, color = TeddTokens.InkMuted)
        Text(
            text = if (hideBalance) "•••• $mainCurrency" else fmtMoney(mainTotal, mainCurrency, compact = false),
            style = TeddType.Numeral.copy(fontSize = if (compact) 26.sp else 32.sp, lineHeight = if (compact) 30.sp else 38.sp),
            color = TeddTokens.Ink,
            modifier = Modifier.padding(top = 6.dp),
        )
        Text(
            text = "$activeCount compte${if (activeCount > 1) "s" else ""}",
            color = TeddTokens.InkMuted,
            fontSize = 12.sp,
            modifier = Modifier.padding(top = 2.dp),
        )
        if (others.isNotEmpty()) {
            Column(modifier = Modifier.padding(top = 10.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                others.forEach { (currency, total) ->
                    Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                        Text(currency, color = TeddTokens.InkMuted, fontSize = 12.sp, modifier = Modifier.weight(1f))
                        Text(
                            text = if (hideBalance) "••••" else fmtMoney(total, currency, compact = false),
                            style = TeddType.Mono,
                            color = TeddTokens.InkMuted,
                        )
                    }
                }
            }
        }
    }
}
